import {
    CaretRightOutlined,
    RightOutlined,
    PrinterOutlined,
    EyeOutlined,
    CheckCircleTwoTone,
} from "@ant-design/icons";
import {
    Collapse,
    Row,
    Col,
    Button,
    Form,
    Input,
    Select,
    DatePicker,
    Alert,
    notification,
    Typography,
    Space,
    Spin,
    Card,
    Avatar,
    Descriptions,
    Modal,
    Radio
} from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useNavigate, useParams , useHref, useLocation } from "react-router-dom";

import memberService from "../../api/member.service";
import ProgrammeCommercialService from "../../api/programme.commercial.service";
import ProgrammeService from "../../api/programme.service";

import timeSlotService from "../../api/time.slot.service";

import {
    DATE_FORMAT_DMY_SLASH,
    MEMBER_ACCOUNT_ID,
    ROUND_OFF_ACCOUNT_ID,
    SAVE_SUCCESS_MSG,
    SUCCESS_STATUS,
    UPDATE_SUCCESS_MSG,
    BANK_CHARGES_ACCOUNT_ID,
    ADD_ONE_PAYMENT_MODE,
    EDIT_MODE,
    ADD_MODE,
    PAYMENT_SECTION_REQUIRED_MESSAGE,
    TAP_MEMBERSHIP_ADMISSION_CREDIT_ACCOUNT_ID,
    CGST_ID_9_PERCENT,
    SGST_ID_9_PERCENT,
    TAP_TAG
} from "../../utility/Constants";

import TimeSlotEnrollment from "../enrollment/TimeSlotEnrollment";
import moment from "moment";
import enrollmentService from "../../api/enrollment.service";
import commonUtility from "../../utility/Utils";
import EnrollmentComponent from "../enrollment/commercial-components/EnrollmentComponent";
import accountService from "../../api/account.service";
import OtherItems from "../enrollment/commercial-components/OtherItems";
import TestFormItem from "../enrollment/commercial-components/TestFormItem";
import PaymentComponent from "../enrollment/commercial-components/PaymentComponent";
import paymentService from "../../api/payment.service";
import StudentCardInfo from "../common/StudentCardInfo";
import { useSelector } from "react-redux";
import ModalWithMessageAndAction from "../common/ModalWithMessageAndAction";
import Paragraph from "antd/lib/skeleton/Paragraph";
import { PRINT_BASE_URL } from "../../utility/URL";
const { Panel } = Collapse;
const { Option } = Select;
const { TextArea } = Input;
const { Text } = Typography;

const defaultFormValues = {
    mode: "ADD",
    enrollment_id: 0,
    member_id: 0,
    programme_id: 0,

    voucher_id: 0,
    date_of_join: null,
    enrollment_start_date: null,
    enrollment_end_date: null,
    is_waiver: 'N',
    cr_ac_id: TAP_MEMBERSHIP_ADMISSION_CREDIT_ACCOUNT_ID,
    student_account_id: MEMBER_ACCOUNT_ID,
    member_opening_balance: 0,
    receipt_id: 0,
    receipt_no: "",
    receipt_date: null,
    is_payment_done: "N",
    is_gst_bill:"Y",
    no_of_months: 0,
    for_month: 0,
    // adjust_amount : 0,
    // adjust_receipt_id : 0,
    entry_from: "A",
    round_off_amount: 0,
    round_off_account_id: ROUND_OFF_ACCOUNT_ID,
    total_bank_charges: 0,
    bank_charges_account_id: BANK_CHARGES_ACCOUNT_ID,
    taxable_amount: 0,
    rate_per_month:0,
    cgst_id: CGST_ID_9_PERCENT,
    cgst_rate: 9,
    cgst_amount: 0,

    sgst_id: SGST_ID_9_PERCENT,
    sgst_rate: 9,
    sgst_amount: 0,

    member_trainee:'MEMBER'

};

const TapMembership = () => {
    const [form] = Form.useForm();

    const params = useParams();
    
    let navigate = useNavigate();
    const location = useLocation();
    // const { pathname, search, hash } = location;
    //const href  = useHref();


    const state = useSelector((state) => state.otheritem);


    const [printURL, setPrintURL] = useState("");
    const [enrollmentID, setEnrollmentID] = useState(0);
    const [receiptID, setReceiptID] = useState(0);
    const [paymentID, setPaymentID] = useState(0);
    const [memberID, setMemberID] = useState(0);

    const [programmeGroupList, setProgrammeGroupList] = useState([]);
    const [memberList, setMemberList] = useState([]);
    const [tapMemberShipFeeAmount, setTapMemberShipFeeAmount] = useState(0);
    const [isAlreadyMemberEnrolled, setIsAlreadyMemberEnrolled] = useState(false);
    const [alreadyMemberEnrolledMessage, setAlreadyMemberEnrolledMessage] =
        useState("");


    const [programmeID, setProgrammeID] = useState([]);
    const [programmeGroupID, setProgrammeGroupID] = useState(0);
    const [lastMembershipValidity, setLastMembershipValidity] = useState("");
    const [lastMembershipValidEndDate, setLastMembershipValidEndDate] = useState("");





    const [accountList, setAccountList] = useState([]);

    const [isFormChanged, setIsFormChanged] = useState(false);

    const [totalAmount, setTotalAmount] = useState(0);
    const [totalDiscountAmount, setTotalDiscountAmount] = useState(0);
    const [totalTaxableAmount, setTotalTaxableAmount] = useState(0);
    const [totalCGSTAmount, setTotalCGSTAmount] = useState(0);
    const [totalSGSTAmount, setTotalSGSTAmount] = useState(0);
    const [totalPayableAmount, setTotalPayableAmount] = useState(0);
    const [totalNetAmount, setTotalNetAmount] = useState(0);
    const [totalRoundOff, setTotalRoundOff] = useState(0);
    const [totalBankCharges, setTotalBankCharges] = useState(0);


    // Payment useState
    const [paymentPaidList, setPaymentPaidList] = useState([]);
    const [totalPaidAmount, setTotalPaidAmount] = useState(0);
    const [remainingAmount, setRemainingAmount] = useState(0);

    const [isSaveLoaderEnable, setSaveLoaderEnable] = useState(false);

    const [openModal, setOpenModal] = useState(false);
    const [responseModalTitle, setResponseModalTitle] = useState("");
    const [responseModalMessage, setResponseModalMessage] = useState("");



    const [cgstList, setCgstList] = useState([]);
    const [sgstList, setSgstList] = useState([]);
    const [igstList, setIgstList] = useState([]);


    //Wave previous value hold 
    const [savePreviosValueForWave, setSavePreviosValueForWave] = useState({
        rate_per_month: 0,
        taxable_amount: 0,
        cgst_id: 0,
        cgst_amount: 0,
        cgst_disable: false,
        sgst_id: 0,
        sgst_amount: 0,
        sgst_disable: false,
        net_amount: 0

    });

    // member Info
    const [memberDisplayInfo, setMemberDisplayInfo] = useState({
        memberName: "",
        memberPrimaryMobile: "",
        memberFatherName: "",
        memberDOB: "",
        profilePic: "",
    });

    const [memberDisplayOtherInfo, setMemberDisplayOtherInfo] = useState({
        joinDate: "",
        validity: "",
    });


    const [memberOrTrainee, setMemberOrTrainee] = useState("MEMBER");

    // const [shortAdjustmentData,setShortAdjustmentData] = useState({
    //     adjust_amount : 0,
    //     adjust_receipt_id : 0,
    //   });

    const onTapMembershipSave = async (values) => {
        console.log("values", values);
        // return false;
    
        let isWaveReceipt;
        if (values.payable_amount === 0) {
            isWaveReceipt = "Y";
        } else {
            isWaveReceipt = "N";
        }
    
        if (values.payment_data.length > 0) {
            setPrintURL("");
            setSaveLoaderEnable(true)
            const data = {
                formdata: {
                    ...values,
                    is_wave_receipt: isWaveReceipt
                }
            };
            console.log("dataTap", data)
            setOpenModal(false);
            setResponseModalTitle("")
            setResponseModalMessage("")
    
            enrollmentService.enrollmentTAPSave(data).then((res) => {
                if (isWaveReceipt === 'Y') {
                    notification.error({
                        message: 'No Reciept No. Generated',
                        description: 'Reciept No. will not be generated against this transaction.',
                        placement: 'bottom',
                        style: { color: 'red' }
                    });
                }
                if (res.data.response_status == SUCCESS_STATUS && res.data.response_data.affectedRows == undefined) {
                    const resp_data = res.data.response_data;
    
                    setOpenModal(true)
                    setResponseModalTitle("Success")
                    setResponseModalMessage(`${SAVE_SUCCESS_MSG}`)
    
                    const print_url = `${PRINT_BASE_URL}tap/tapreceipt/${resp_data.enrollment_id}/${resp_data.receipt_master_id}/${resp_data.payment_master_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`
                    setPrintURL(print_url);
    
                } else if (res.data.response_data.affectedRows > 0) {
                    const resp_data = res.data.response_data;
    
                    setOpenModal(true)
                    setResponseModalTitle("Success")
                    setResponseModalMessage(`${UPDATE_SUCCESS_MSG}`)
    
                    const print_url = `${PRINT_BASE_URL}tap/tapreceipt/${resp_data.enrollment_id}/${resp_data.receipt_master_id}/${resp_data.payment_master_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`
                    setPrintURL(print_url);
                }
                setSaveLoaderEnable(false)
    
            }).then(() => {
                setSaveLoaderEnable(false)
            });
        } else {
            commonUtility.openNotificationWithType("error", "bottomRight", "Error", ADD_ONE_PAYMENT_MODE);
        }
    };
    

    const onChangeCollapse = (key) => {
        console.log(key);
    };

    /*
        const onSelectProgrammeGroup = (value, event) => {
          setProgrammeGroupID(value);
          form.setFieldsValue({ day_slot: [] });
      
        };
        */

    const onDateOfJoinChange = (date, dateString) => {
        const no_of_month = form.getFieldValue("for_month")
        form.setFieldsValue({
            date_of_join: dateString,
            enrollment_date: dateString,
        });

        if (commonUtility.sanitizeValue(parseInt(no_of_month)) > 0) {
            generateValidityPeriod(dateString, no_of_month);
        }
    };

    const onChangeForMonth = (e, v) => {
        const dateString = form.getFieldValue("date_of_join");
        const no_of_month = form.getFieldValue("for_month");

        if (commonUtility.sanitizeObject(dateString) && parseInt(no_of_month) > 0) {
            generateValidityPeriod(dateString, no_of_month);
        }


        const rate = form.getFieldValue("rate_per_month");
        if (parseInt(no_of_month) > 0 && parseFloat(rate) > 0) {
            const taxable_amount = rate * no_of_month;
            form.setFieldsValue({
                taxable_amount: parseFloat(taxable_amount).toFixed(2),
            });
        }
        else {

            
            form.setFieldsValue({
                taxable_amount: 0,
                //rate_per_month: 0,
                //for_month: 0,
                cgst_id: CGST_ID_9_PERCENT,
                cgst_amount: 0,
                cgst_rate: 9,
                sgst_id: SGST_ID_9_PERCENT,
                sgst_amount: 0,
                sgst_rate: 9,

            });
        }

        const cgst_rate = form.getFieldValue("cgst_rate");
        onSelectTapRegCGST(e, "OTHER", cgst_rate)

        const sgst_rate = form.getFieldValue("sgst_rate");
        onSelectTapRegSGST(e, "OTHER", sgst_rate)

    };


    const generateValidityPeriod = (dateString, no_of_month) => {


        console.log(dateString, no_of_month)

        if(commonUtility.sanitizeObject(dateString) != "") {
            const formatDate = dateString.split("/").reverse().join("-");
            const joindate = new Date(formatDate);
            const validity_end_date = commonUtility.addMonthsToDate(parseInt(no_of_month), joindate)
    
            form.setFieldsValue({
                enrollment_date: dateString,
                enrollment_start_date: dateString,
                enrollment_end_date: validity_end_date,
            });
    
            setMemberDisplayOtherInfo({
                joinDate: dateString,
                validity: `${dateString} to ${validity_end_date.split("-").join("/")}`
            });
        }
        else{
            form.setFieldsValue({
                enrollment_date: "",
                enrollment_start_date: "",
                enrollment_end_date: "",
            });
            setMemberDisplayOtherInfo({
                joinDate: "",
                validity: ""
            });
        }

        
    }



    const onSelectTapRegCGST = (e, tag, rate) => {
        if (e) {
            let rateValue = 0;
            if (tag == "DROPDOWN") {
                rateValue = e.rate
            }
            else {
                rateValue = rate
            }

            const taxable = form.getFieldValue("taxable_amount");
            form.setFieldsValue({
                cgst_amount: ((taxable * rateValue) / 100).toFixed(2),
                cgst_rate: rateValue,
            });
        }
        else {
            form.setFieldsValue({
                cgst_amount: 0,
                cgst_rate: 0,
            });
        }

        calulateGstAndPayable()
    };


    const onSelectTapRegSGST = (e, tag, rate) => {


        if (e) {
            let rateValue = 0;
            if (tag == "DROPDOWN") {
                rateValue = e.rate
            }
            else {
                rateValue = rate
            }

            const taxable = form.getFieldValue("taxable_amount");
            form.setFieldsValue({
                sgst_amount: ((taxable * rateValue) / 100).toFixed(2),
                sgst_rate: rateValue,
            });
        }
        else {
            form.setFieldsValue({
                sgst_amount: 0,
                sgst_rate: 0,
            });
        }

        calulateGstAndPayable()
    };





    const calulateGstAndPayable = () => {

        const taxable_amount = commonUtility.sanitizeValue(form.getFieldValue("taxable_amount"));
        const cgst_amount = commonUtility.sanitizeValue(form.getFieldValue("cgst_amount"));
        const sgst_amount = commonUtility.sanitizeValue(form.getFieldValue("sgst_amount"));
        const total_gst = parseFloat(cgst_amount) + parseFloat(sgst_amount);
        const total_payable = parseFloat(cgst_amount) + parseFloat(sgst_amount) + parseFloat(taxable_amount);
        form.setFieldsValue({
            total_gst_amount: total_gst,
            net_amount: total_payable
        });
        onFormCalculation()
    };



    useEffect(() => {
        const rcpt_dt = commonUtility.dateFormatDDMMYYYY(new Date(), "/");
        form.setFieldsValue({
            receipt_date: rcpt_dt,
        });
    }, []);

    useEffect(() => {
        const data = {
            formdata: { short_code: "TAP" },
        };
        ProgrammeService.programmeByCode(data).then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setProgrammeID(res.data.response_data[0].programme_id);
                form.setFieldsValue({
                    programme_id: res.data.response_data[0].programme_id,
                });
            }
        });
    }, []);

    useEffect(() => {
        accountService.accountProfitAndIncomeList().then((res) => {
            setAccountList(res.data.response_data);
        });
    }, []);





    const onChangeFreshPromoted = (e) => {

        form.setFieldsValue({
          member_search: "",
          member_id: 0,
          member_name: "",
          member_primary_mobile: "",
          member_father_name: "",
          date_of_birth: null,
        });
    
        setMemberDisplayInfo({
          memberName: "",
          memberPrimaryMobile: "",
          memberFatherName: "",
          memberDOB: "",
          profilePic: "",
        });
    
    
        const data = {
          formdata: { programme_id: TAP_TAG },
        };
    
        setMemberList([]);
        if (e.target.value == "MEMBER") {
            memberService.memberListForTapRegistration().then((res) => {
                if (res.data.response_status === SUCCESS_STATUS) {
                    setMemberList(res.data.response_data);
                    setMemberOrTrainee("MEMBER");


                    form.setFieldsValue({
                        taxable_amount: 0,
                        cgst_id: CGST_ID_9_PERCENT,
                        cgst_amount: 0,
                        cgst_rate: 9,
                        sgst_id: SGST_ID_9_PERCENT,
                        sgst_amount: 0,
                        sgst_rate: 9,
        
                    });
        
                getTapRate();
                calculateRate();
                const cgst_rate = form.getFieldValue("cgst_rate");
                onSelectTapRegCGST(e, "OTHER", cgst_rate)
        
                const sgst_rate = form.getFieldValue("sgst_rate");
                onSelectTapRegSGST(e, "OTHER", sgst_rate)


                }
            });
            
           

        }
        else {
            // Get TRAINEE List
            setMemberOrTrainee("TRAINEE")
            getTraineeList();
            form.setFieldsValue({
                rate_per_month: 0,
                taxable_amount: 0,
                cgst_id: '',
                cgst_amount: 0,
                sgst_id: '',
                sgst_amount: 0,
                net_amount: 0
            });
           
            
        }
       
        onFormCalculation();

      }

    
    const getTraineeList = () => {
        setMemberList([]);
        enrollmentService.tapMemberListTrainee().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setMemberList(res.data.response_data);
            }
        });
    }

    useEffect(()=>{
        if(memberOrTrainee == "TRAINEE"){
            getTraineeList();
        }
        
    },[memberOrTrainee])

    const onSelectMember = (value) => {
        if (value > 0) {
            setIsAlreadyMemberEnrolled(false);
            setAlreadyMemberEnrolledMessage("");


            const data = {
                formdata: { member_id: value, programme_id: programmeID },
            };
            ProgrammeService.tapMemberDetail(data).then((res) => {
                if (res.data.response_status === SUCCESS_STATUS) {
                    const response = res.data.response_data;

                    form.setFieldsValue({
                        member_id: response.memberData[0].member_id,
                        member_search: response.memberData[0].member_id,
                        member_name:
                            response.memberData[0].member_fname +
                            " " +
                            response.memberData[0].member_lname,
                        member_primary_mobile: response.memberData[0].primary_mobile,
                        member_father_name: response.memberData[0].father_name,
                        date_of_birth: response.memberData[0].date_of_birth,
                        //  group_id: response.enrolmentData[0].group_id,
                        //  enrollment_id: response.enrolmentData[0].enrollment_id,
                    });

                    setMemberDisplayInfo({
                        memberName: `${response.memberData[0].member_fname} ${response.memberData[0].member_lname}`,
                        memberPrimaryMobile: response.memberData[0].primary_mobile,
                        memberFatherName: response.memberData[0].father_name,
                        memberDOB: response.memberData[0].date_of_birth,
                        profilePic: response.memberData[0].profile_picture,
                    });

                    setLastMembershipValidity("");
                    setLastMembershipValidEndDate("");
                    form.setFieldsValue({
                        join_date: "",
                        date_of_join: "",
                    });

                    if (response.enrolmentData.length > 0) {
                        setLastMembershipValidity(`${response.enrolmentData[0]?.enrollment_start_date} to ${response.enrolmentData[0]?.enrollment_end_date}`);
                        setLastMembershipValidEndDate(response.enrolmentData[0]?.enrollment_end_date ? response.enrolmentData[0]?.enrollment_end_date : "")
                    }

                    /*
                    if(response?.shortExcessData) {
                        setShortAdjustmentData({
                          adjust_receipt_id: response.shortExcessData.adjust_receipt_id,
                          adjust_amount: response.shortExcessData.adjust_amount,
                        });
            
                        form.setFieldsValue({
                          adjust_receipt_id: response.shortExcessData.adjust_receipt_id,
                          adjust_amount: response.shortExcessData.adjust_amount,
                        });
                    }
                    */


                    // if(){

                    // }

                    /*
                      setMemberDisplayOtherInfo({
                        joinDate: response.enrolmentData[0].enrollment_date,
                        validity: `${response.enrolmentData[0].enrollment_start_date} to ${response.enrolmentData[0].enrollment_end_date}`,
                      });
            
                      if (response.paymentData.length > 0) {
                        form.setFieldsValue({
                          date_of_join: response.paymentData[0].nexy_pay_month,
                        });
            
                        setLastPaidMonthHistoryText(response.paymentData[0].last_paid_date);
                      } else {
                        form.setFieldsValue({
                          date_of_join: response.enrolmentData[0].enrollment_date,
                        });
                      }
            
                      setEnrollmentID(response.enrolmentData[0].enrollment_id);
                      setProgrammeGroupID(response.enrolmentData[0].group_id);
                      */
                }
            });
        }
    };



    const onWaveChange = (value, e) => {
        //  console.log("E",e,"Value",v);



        if (value == "Y") {
            setSavePreviosValueForWave({
                rate_per_month: form.getFieldValue("rate_per_month"),
                taxable_amount: form.getFieldValue("taxable_amount"),
                cgst_id: form.getFieldValue("cgst_id"),
                cgst_disable: true,
                cgst_amount: form.getFieldValue("cgst_amount"),
                sgst_id: form.getFieldValue("sgst_id"),
                sgst_amount: form.getFieldValue("sgst_amount"),
                sgst_disable: true,
                net_amount: form.getFieldValue("net_amount")
            })

            form.setFieldsValue({
                rate_per_month: 0,
                taxable_amount: 0,
                cgst_id: '',
                cgst_amount: 0,
                sgst_id: '',
                sgst_amount: 0,
                net_amount: 0
            });
        }
        else {
           
            form.setFieldsValue({
                rate_per_month: savePreviosValueForWave.rate_per_month,
                taxable_amount: savePreviosValueForWave.taxable_amount,
                cgst_id: savePreviosValueForWave.cgst_id,
                cgst_amount: savePreviosValueForWave.cgst_amount,
                sgst_id: savePreviosValueForWave.sgst_id,
                sgst_amount: savePreviosValueForWave.sgst_amount,
                net_amount: savePreviosValueForWave.net_amount,
            });

            setSavePreviosValueForWave({
                cgst_disable: false,
                sgst_disable: false,
            });

            getTapRate();
            calculateRate();

           
        }


        onFormCalculation();
    }


    const calculateRate = () => {
        const no_of_month = form.getFieldValue("for_month");
        //const rate = form.getFieldValue("rate_per_month");
        const rate = tapMemberShipFeeAmount;
        if(parseInt(no_of_month) > 0 && parseFloat(rate) > 0) {
            const taxable_amount = rate * no_of_month;
            form.setFieldsValue({
                taxable_amount: parseFloat(taxable_amount).toFixed(2),
            });
        }
    }

    const onFormCalculation = () => {

        setIsFormChanged(false);

        let total_amount = parseFloat(commonUtility.sanitizeValue(form.getFieldValue("taxable_amount")));
        let total_discount = 0;
        let total_taxable = parseFloat(commonUtility.sanitizeValue(form.getFieldValue("taxable_amount")));
        let total_cgst_amount = parseFloat(commonUtility.sanitizeValue(form.getFieldValue("cgst_amount")));
        let total_sgst_amount = parseFloat(commonUtility.sanitizeValue(form.getFieldValue("sgst_amount")));

        let short_access_amount = parseFloat(commonUtility.sanitizeValue(form.getFieldValue("adjust_amount")));

        let total_payable_amount = parseFloat(commonUtility.sanitizeValue(total_taxable)) + parseFloat(commonUtility.sanitizeValue(total_cgst_amount)) + parseFloat(commonUtility.sanitizeValue(total_sgst_amount)) + short_access_amount;

        const payableAmountDetail = commonUtility.getRoundOfAmount(total_payable_amount);
        const new_payable_amount = payableAmountDetail.newPayableAmount;
        const roundoff_amount = payableAmountDetail.roundoffAmount;

        form.setFieldsValue({
            payable_amount: new_payable_amount,
            round_off_amount: roundoff_amount,
        });

        setTotalAmount(total_amount.toFixed(2));
        setTotalDiscountAmount(total_discount.toFixed(2));
        setTotalTaxableAmount(total_taxable.toFixed(2));
        setTotalCGSTAmount(total_cgst_amount.toFixed(2));
        setTotalSGSTAmount(total_sgst_amount.toFixed(2));
        setTotalNetAmount(total_payable_amount.toFixed(2));
        setTotalPayableAmount(new_payable_amount.toFixed(2));

        setTotalRoundOff(0);
        if (roundoff_amount) {
            setTotalRoundOff(`${roundoff_amount}`);
        }

        setIsFormChanged(true);

    };

    /*
          useEffect(() => {
            onFormCalculation();
          }, [form,state.otheritem]);
          */

    // useEffect(() => {
    // onFormCalculation();
    // }, [isFormChanged]);



    // Payment mode Data
    const [isPaymentModeDisabled, setIsPaymentModeDisabled] = useState(false);
    const addPaymentMode = () => {
        const selected_payment_mode_text = form.getFieldValue("selected_payment_mode_text");
        const mode = form.getFieldValue("selected_payments_mode");
        const paid_amount = form.getFieldValue("paid_amount");
        const dr_account_id = form.getFieldValue("dr_account_id");
        const cheque_no = form.getFieldValue("cheque_no");
        const cheque_date = form.getFieldValue("cheque_date");
        const bank = form.getFieldValue("bank");
        const branch = form.getFieldValue("branch");
        const bank_charges = commonUtility.sanitizeValue(form.getFieldValue('bank_charges'));
        const payment_ref = form.getFieldValue('payment_ref');

        let bank_charges_amount = 0;
        if (commonUtility.sanitizeValue(bank_charges) > 0) {
            bank_charges_amount = (parseFloat(paid_amount) * parseFloat(bank_charges)) / 100;
            bank_charges_amount = Math.round(bank_charges_amount);
        }

        //setIsOtherComponentRender(false)

        if (
            commonUtility.sanitizeObject(selected_payment_mode_text) &&
            commonUtility.sanitizeObject(mode) && commonUtility.sanitizeValue(paid_amount) >=0
            ) {
            let amount = parseFloat(paid_amount) + parseFloat(bank_charges_amount);
            setPaymentPaidList([
                ...paymentPaidList,
                {
                    rowKey:commonUtility.randomID(),
                    mode_description: selected_payment_mode_text,
                    payment_mode_text: selected_payment_mode_text,
                    payment_mode_id: mode,
                    payment_mode: mode,
                    dr_account_id: dr_account_id,
                    amount: amount,
                    paid_amount: paid_amount,
                    cheque_no: cheque_no,
                    cheque_date: cheque_date,
                    bank_name: bank,
                    bank_branch: branch,
                    bank_charges: bank_charges_amount,
                    payment_ref: payment_ref,
                },
            ]);

            setIsPaymentModeDisabled(true);

            form.setFieldsValue({
                selected_payment_mode_text:"",
                selected_payments_mode : "",
                cheque_no:"",
                cheque_date:"",
                bank:"",
                payment_ref:"",
              });
        }
        else{
            commonUtility.openNotificationWithType("error","bottomRight","Error",PAYMENT_SECTION_REQUIRED_MESSAGE);
        }
    };

    // Remove payment Mode
    const removePayment = (index) => {
        const list = [...paymentPaidList];
        list.splice(index, 1);
        setPaymentPaidList(list);

        if (list.length === 0) {
            setIsPaymentModeDisabled(false);
          }
    };

    // useEffect(()=>{

    // },[])


    useEffect(() => {
        setRemainingAmount(
            parseFloat(totalPayableAmount) + parseFloat(totalBankCharges) - parseFloat(totalPaidAmount)
        );
    }, [totalPayableAmount, totalPaidAmount]);


    /***************************************ADD MODE***************************/
    /***************************************ADD MODE***************************/
    /***************************************ADD MODE***************************/
    useEffect(() => {
        setEnrollmentID(params.enrollmentid);
        setReceiptID(params.receiptid);
        setPaymentID(params.paymentid);
    }, []);

    /*
      useEffect(() => {
        onSelectMember(memberID);
        console.log(memberID);
      }, [programmeID, memberID]);
    
      useEffect(() => {
        const data = {
          formdata: { programme_id: programmeID },
        };
        memberService.memberListByProgramme(data).then((res) => {
          if (res.data.response_status === SUCCESS_STATUS) {
            setMemberList(res.data.response_data);
          }
        });
      }, [programmeID, memberID]);
      */

    /** TAP Additional */

    useEffect(() => {
        memberService.memberListForTapRegistration().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setMemberList(res.data.response_data);
            }
        });
    }, [memberID]);

    useEffect(() => {
        getTapRate();
    }, []);

    useEffect(() => {
        const data = {
            formdata: { gstType: "CGST", usedfor: "O" },
        };
        accountService.gstListByInputType(data).then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setCgstList(res.data.response_data);
            }
        });
    }, []);

    useEffect(() => {
        const data = {
            formdata: { gstType: "SGST", usedfor: "O" },
        };
        accountService.gstListByInputType(data).then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setSgstList(res.data.response_data);
            }
        });
    }, []);


    const getTapRate = () => {
        ProgrammeService.tapMembershipFee().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                //setMemberList(res.data.response_data);
                const fee_data = res.data.response_data[0];

                console.log("Mode",form.getFieldValue("mode"))
                
                setTapMemberShipFeeAmount(fee_data.membership_fees);
                    form.setFieldsValue({
                        rate_per_month: fee_data.membership_fees,
                    });
            }
        });
    }

    /** ****************************************************************************
     * ******************************* Edit Mode ***********************************
     * *****************************************************************************
     */

    /**
     * Set Master Data Programme Edit Mode
     */

    useEffect(() => {
        if (enrollmentID > 0 && receiptID > 0) {
            const data = {
                formdata: {
                    enrollment_id: enrollmentID,
                },
            };
            enrollmentService.JCPenrollmentDatabyID(data).then((res) => {
                if (res.data.response_status === SUCCESS_STATUS) {
                    const enrollment_data = res.data.response_data[0];

                    setProgrammeID(enrollment_data.programme_id);
                    setProgrammeGroupID(enrollment_data.group_id);
                    setMemberOrTrainee(enrollment_data.member_trainee);
                    form.setFieldsValue({
                        mode: "EDIT",
                        enrollment_id: enrollmentID,
                        member_search: enrollment_data.member_id,
                        member_id: enrollment_data.member_id,
                        member_name: `${enrollment_data.member_fname} ${enrollment_data.member_lname}`,
                        member_primary_mobile: enrollment_data.primary_mobile,
                        member_father_name:
                            enrollment_data.father_name != null &&
                                enrollment_data.father_name != ""
                                ? enrollment_data.father_name
                                : "",
                        date_of_birth: enrollment_data.date_of_birth,
                        programme_id: enrollment_data.programme_id,
                        group_id: enrollment_data.group_id,
                        join_date:
                            enrollment_data.enrollment_date != null &&
                                enrollment_data.enrollment_date != ""
                                ? moment(enrollment_data.enrollment_date, DATE_FORMAT_DMY_SLASH)
                                : "",
                        date_of_join: enrollment_data.enrollment_date,
                        enrollment_date: enrollment_data.enrollment_start_date,
                        enrollment_start_date: enrollment_data.enrollment_start_date,
                        enrollment_end_date: enrollment_data.enrollment_end_date,
                        member_trainee: enrollment_data.member_trainee,
                    });

                    setMemberDisplayInfo({
                        memberName: `${enrollment_data.member_fname} ${enrollment_data.member_lname}`,
                        memberPrimaryMobile: enrollment_data.primary_mobile,
                        memberFatherName:
                            enrollment_data.father_name != null &&
                                enrollment_data.father_name != ""
                                ? enrollment_data.father_name
                                : "",
                        memberDOB: enrollment_data.date_of_birth,
                        profilePic: enrollment_data.profile_picture,
                    });

                    setMemberDisplayOtherInfo({
                        joinDate: enrollment_data.enrollment_date,
                        validity: `${enrollment_data.enrollment_start_date} to ${enrollment_data.enrollment_end_date}`,
                    });
                    setIsPaymentModeDisabled(true);
                }
            });
        }
    }, [enrollmentID]);


    /**
     * Set Total Payment Amount Data
     */


    useEffect(() => {
        if (receiptID > 0) {
            const data = {
                formdata: {
                    receipt_id: receiptID,
                },
            };

        
            /*
            enrollmentService.JCPReceiptDatabyID(data).then((res) => {
                if (res.data.response_status === SUCCESS_STATUS) {
                    const receipt_data_master = res.data.response_data[0];
                    console.log('receipt_data_master',receipt_data_master.member_trainee);
                    setMemberOrTrainee(receipt_data_master.member_trainee);
                    form.setFieldsValue({
                        //member_trainee: receipt_data_master.member_trainee,
                        member_trainee: receipt_data_master.member_trainee,
                    });
                }
            });
            */
            /*
            enrollmentService.JCPReceiptDatabyID(data).then((res) => {
                if (res.data.response_status === SUCCESS_STATUS) {
                   
                    const receipt_data = res.data.response_data[0];
                    setShortAdjustmentData({
                        adjust_receipt_id: receipt_data.adjust_receipt_id,
                        adjust_amount: receipt_data.adjust_amount,
                      });
                    console.warn(receipt_data);
                    form.setFieldsValue({
                        mode: "EDIT",
                        adjust_receipt_id: receipt_data.adjust_receipt_id,
                        adjust_amount: receipt_data.adjust_amount,
                        
                    });
                }
            });
            */

          



            //Receipt Detail Data :

            enrollmentService.componentDetailsAgainstReceiptTap(data).then((res) => {
                if (res.data.response_status === SUCCESS_STATUS) {


                    setTotalAmount(0);
                    setTotalDiscountAmount(0);
                    setTotalTaxableAmount(0);
                    setTotalCGSTAmount(0);
                    setTotalSGSTAmount(0);
                    setTotalNetAmount(0);
                    setTotalPayableAmount(0);

                    const receipt_data = res.data.response_data[0];
                  //  console.log("Response Data 112 ", receipt_data)


                    form.setFieldsValue({
                        mode: "EDIT",
                        // no_of_months: receipt_data.no_of_months,
                        receipt_id: receipt_data.receipt_master_id,
                        // receipt_no: receipt_data.receipt_no,

                        taxable_amount: receipt_data.taxable_amount,
                        cgst_id: receipt_data.cgst_id,
                        cgst_amount: receipt_data.cgst_amount,
                        cgst_rate: receipt_data.cgst_rate,
                        sgst_id: receipt_data.sgst_id,
                        sgst_amount: receipt_data.sgst_amount,
                        sgst_rate: receipt_data.sgst_rate,
                        total_gst_amount: receipt_data.total_gst_amount,
                        net_amount: receipt_data.net_amount,
                        cr_ac_id: receipt_data.cr_ac_id,
                        is_waiver: receipt_data.is_waiver,




                    });

                    setTotalAmount(receipt_data.amount.toFixed(2));
                    setTotalTaxableAmount(receipt_data.taxable_amount.toFixed(2));
                    setTotalCGSTAmount(receipt_data.cgst_amount.toFixed(2));
                    setTotalSGSTAmount(receipt_data.sgst_amount.toFixed(2));

                    const total_net_amount =
                        receipt_data.taxable_amount +
                        receipt_data.cgst_amount +
                        receipt_data.sgst_amount;

                    setTotalNetAmount(total_net_amount.toFixed(2));
                    setTotalPayableAmount(receipt_data.net_amount.toFixed(2));



                }
            });


        }
    }, [receiptID]);




    /**
     * payment Info && Payment List Detail
     */

    useEffect(() => {
        if (receiptID > 0 && enrollmentID > 0 && paymentID > 0) {
            const data = {
                formdata: {
                    payment_id: paymentID,
                },
            };
            paymentService.paymentmasterDataByID(data).then((res) => {
                if (res.data.response_status === SUCCESS_STATUS) {
                    setTotalPaidAmount(0);
                    setTotalRoundOff(0);

                    const payment_data = res.data.response_data[0];
                    form.setFieldsValue({
                        mode: "EDIT",
                        payment_id: payment_data.payment_id,
                        payment_date: payment_data.payment_date,
                        payment_no : payment_data.payment_no,
                        date_of_payment: payment_data.payment_date
                            ? moment(payment_data.payment_date, DATE_FORMAT_DMY_SLASH)
                            : "",

                        //member_opening_balance: payment_data.short_excess_amount,
                        payment_amount: payment_data.payment_amount,
                        voucher_id: payment_data.voucher_id,
                        // receipt_no: payment_data.payment_no,
                        payable_amount: payment_data.total_payble_amount,
                        for_month: payment_data.for_month,
                        rate_per_month: payment_data.rate_per_month,
                        narration: payment_data.narration,
                        round_off_amount: payment_data.round_off_amount,
                        round_off_account_id: payment_data.round_off_account_id,
                    });

                    setTotalPaidAmount(payment_data.payment_amount.toFixed(2));
                    setTotalRoundOff(payment_data.round_off_amount);
                }
            });
        }
    }, [paymentID]);



    useEffect(() => {
        if (receiptID > 0 && enrollmentID > 0 && paymentID > 0) {
            const data = {
                formdata: {
                    payment_id: paymentID,
                },
            };

            paymentService.paymentDetailsDataByID(data).then((res) => {
                if (res.data.response_status === SUCCESS_STATUS) {
                    let payment_list = res.data.response_data;
                    const newData = payment_list.map((details) => {
                        return { ...details };
                    });
                    setPaymentPaidList(newData);
                }
            });


        }
    }, [receiptID, paymentID]);

    useEffect(() => {
        const total_paid_amount = paymentPaidList.reduce((a, v) => a = a + parseFloat(v.amount), 0);
        const total_bank_charges = paymentPaidList.reduce((a, v) => a = a + parseFloat(v.bank_charges), 0);

        setTotalBankCharges(parseFloat(commonUtility.sanitizeValue(total_bank_charges)).toFixed(2))
        setTotalPaidAmount(parseFloat(commonUtility.sanitizeValue(total_paid_amount)).toFixed(2))

        form.setFieldsValue({
            payment_amount: total_paid_amount.toFixed(2),
            total_bank_charges: total_bank_charges,
        })

        //  setRemainingAmount(totalPayableAmount -  totalPaidAmount)
    }, [paymentPaidList, receiptID, paymentID]);



    const handleCancel = () => {
        setOpenModal(false);
    };
    function changeLocation(placeToGo) {
        navigate(placeToGo, { replace: true });
        window.location.reload();
    }

    const resetFormFields = () => {
        const defaultFormValues = {
            mode: "ADD",
            enrollment_id: 0,
            member_id: 0,
            programme_id: 0,

            voucher_id: 0,
            date_of_join: null,
            enrollment_start_date: null,
            enrollment_end_date: null,
            cr_ac_id: TAP_MEMBERSHIP_ADMISSION_CREDIT_ACCOUNT_ID,
            student_account_id: MEMBER_ACCOUNT_ID,
            member_opening_balance: 0,
            receipt_id: 0,
            receipt_no: "",
            receipt_date: null,
            is_payment_done: "N",
            no_of_months: 0,
            adjust_amount : 0,
            adjust_receipt_id : 0,
            entry_from: "A",
            is_gst_bill:"Y",
            round_off_amount: 0,
            round_off_account_id: ROUND_OFF_ACCOUNT_ID,
            total_bank_charges: 0,
            bank_charges_account_id: BANK_CHARGES_ACCOUNT_ID,
            taxable_amount: 0,

            cgst_id: CGST_ID_9_PERCENT,
            cgst_rate: 9,
            cgst_amount: 0,

            sgst_id: SGST_ID_9_PERCENT,
            sgst_rate: 9,
            sgst_amount: 0,

            member_trainee:'MEMBER'

        };
    };







    return (
        <div className="form-input-style">
            <Row
                className="login-first-step-row"
                style={{ background: "transparent" }}
            >
                <Col
                    className="form-format-type1 enrollment-form tap-registration"
                    xs={24}
                    xl={24}
                >
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onTapMembershipSave}
                        autoComplete="off"
                        initialValues={defaultFormValues}
                        onFieldsChange={(event) => onFormCalculation()}
                        onKeyUp={(event) => onFormCalculation}
                        onBlur={(event) => onFormCalculation}
                    >
                        <Collapse
                            bordered={false}
                            defaultActiveKey={["programme_jcp", "receipt_jcp"]}
                            onChange={onChangeCollapse}
                            expandIcon={({ isActive }) => (
                                <CaretRightOutlined rotate={isActive ? 90 : 0} />
                            )}
                        >
                            <Panel
                                header={
                                    <>
                                        <h4>Registration Info</h4>
                                    </>
                                }
                                key="programme_jcp"
                                className="mainPanel"
                            >
                                <Row gutter={20}>
                                    <Col xs={24} xl={12}>
                                        <Row gutter={20}>
                                            <Col className="gutter-row" xs={24} xl={24} style={{ marginBottom: 3 }}>
                                                <Form.Item name="member_trainee" label="Member/Trainee">
                                                    <Radio.Group 
                                                    defaultValue="MEMBER" 
                                                    buttonStyle="solid" 
                                                    name="member_trainee_radio" 
                                                    onChange={(e) => onChangeFreshPromoted(e)}
                                                    disabled={enrollmentID > 0 ? true : false} 
                                                    >
                                                        <Radio.Button value="MEMBER">MEMBER</Radio.Button>
                                                        <Radio.Button value="TRAINEE">TRAINEE</Radio.Button>
                                                    </Radio.Group>
                                                </Form.Item>
                                            </Col>
                                            <Col className="gutter-row" xs={24} xl={24}>
                                                <Form.Item
                                                    name="member_search"
                                                    label="Search (Name | Mobile no | Father Name)"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "Select Member / Student",
                                                        },
                                                    ]}
                                                >
                                                    <Select
                                                        // showSearch
                                                        // placeholder="Search to Select"
                                                        // optionFilterProp="children"
                                                        // filterOption={(input, option) =>
                                                        //     option.children.includes(input.toLowerCase())
                                                        // }
                                                        // filterSort={(optionA, optionB) =>
                                                        //     optionA.children
                                                        //         .toLowerCase()
                                                        //         .localeCompare(optionB.children.toLowerCase())
                                                        // }
                                                        // onSelect={(value, event) =>
                                                        //     onSelectMember(value, event)
                                                        // }

                                                        showSearch
                                                        placeholder="Search to Select"
                                                        optionFilterProp="children"
                                                        filterOption={(input, option) =>
                                                            // option.children.includes(input)
                                                            option.children.toLowerCase().includes(input.toLowerCase())
                                                        }
                                                        filterSort={(optionA, optionB) =>
                                                            optionA.children
                                                                .toLowerCase()
                                                                .localeCompare(optionB.children.toLowerCase())
                                                        }
                                                        onSelect={(value, event) =>
                                                            onSelectMember(value, event)
                                                        }
                                                        //disabled={enrollmentID > 0 ? true : false} 
                                                    >
                                                        {memberList.length > 0
                                                            ? memberList.map((member_list) => (
                                                                <Option
                                                                    key={member_list.member_id}
                                                                    value={member_list.member_id}
                                                                >
                                                                    {/* {
                                                                        renderOption();
                                                                            `${member_list.member_fname} ${member_list.member_lname} | ${member_list.primary_mobile}  ${member_list.father_name != null ? member_list.father_name : ""}`
                                                                        
                                                                    } */}

                                                                    {`${member_list.member_fname} ${member_list.member_lname} | ${member_list.primary_mobile}  ${member_list.father_name != null ? member_list.father_name : ""}`}


                                                                </Option>
                                                            ))
                                                            : ""}
                                                    </Select>
                                                </Form.Item>
                                                <Form.Item name="enrollment_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="mode" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="member_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="programme_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="voucher_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="entry_from" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="student_account_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="payment_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="receipt_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="is_gst_bill" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="payable_amount" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="round_off_amount" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="round_off_account_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item label="Bank Charge" name="total_bank_charges" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item label="Bank Charge" name="bank_charges_account_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="payment_amount" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                {
                                                    lastMembershipValidity ? <p style={{ fontWeight: '500' }}>
                                                        Last Membership Validity :  {lastMembershipValidity}
                                                    </p> : <></>
                                                }
                                            </Col>

                                            <Col className="gutter-row" xs={24} xl={12}>
                                                <Form.Item
                                                    name="join_date"
                                                    label="Playing From"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "Playing from is required",
                                                        },
                                                    ]}
                                                >
                                                    <DatePicker
                                                        format={DATE_FORMAT_DMY_SLASH}
                                                        onChange={onDateOfJoinChange}
                                                        style={{ width: "100%" }}
                                                        // disabledDate={(current) => {
                                                        //     if (lastMembershipValidEndDate != "") {
                                                        //         return current <= moment(new Date(commonUtility.dateFormatYYYYMMDD(lastMembershipValidEndDate, "-")), "YYYY-MM-DD").add(1, 'day');
                                                        //     }
                                                        //     else {
                                                        //         return current.isBefore(moment().subtract(1, "day"));
                                                        //     }

                                                        // }}
                                                        inputReadOnly={true}
                                                    />
                                                </Form.Item>
                                                <Form.Item name="date_of_join" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="enrollment_date" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} xl={6}>
                                                <Form.Item name="for_month" label="No Of Month" rules={[
                                                        {
                                                            required: true,
                                                            message: "Enter no of months",
                                                        },
                                                    ]}>
                                                    <Input onChange={(event, value) => {
                                                        onChangeForMonth(event, value);
                                                    }} />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} xl={6}>
                                                <Form.Item name="is_waiver" label="Apply Waive">
                                                    <Select className="text-left" allowClear={false} onChange={(value, event) => onWaveChange(value, event)}>
                                                        <Option value="N" selected>No</Option>
                                                        <Option value="Y">Yes</Option>
                                                    </Select>
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} xl={12} hidden={true}>
                                                <Form.Item
                                                    name="enrollment_start_date"
                                                    label="Programme Valid From"
                                                >
                                                    <Input placeholder="" readOnly={true} />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} xl={12} hidden={true}>
                                                <Form.Item
                                                    name="enrollment_end_date"
                                                    label="Programme Valid To"
                                                >
                                                    <Input placeholder="" readOnly={true} />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} xl={12}>
                                                <Form.Item name="rate_per_month" label="Rate/Month" rules={[
                                                        {
                                                            required: true,
                                                            message: "Enter rate per month",
                                                        },
                                                    ]}>
                                                    <Input placeholder="" readOnly={false}  onChange={(event, value) => {
                                                        onChangeForMonth(event, value);
                                                    }} />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} xl={12}>
                                                <Form.Item name="taxable_amount" label="Total Taxable">
                                                    <Input placeholder="" readOnly={true} />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} xl={6}>
                                                <Form.Item name="cgst_id" label="CGST">
                                                    <Select className="text-left" allowClear={true} onChange={(value, event) => onSelectTapRegCGST(event, "DROPDOWN", 0)}
                                                    //disabled={savePreviosValueForWave.cgst_disable}
                                                    disabled={true}
                                                    >
                                                        {cgstList.length > 0
                                                            ? cgstList.map((cgst_list) => (
                                                                <Option
                                                                    key={cgst_list.id}
                                                                    value={cgst_list.id}
                                                                    rate={cgst_list.rate}
                                                                >
                                                                    {cgst_list.gstDescription}
                                                                </Option>
                                                            ))
                                                            : ""}
                                                    </Select>
                                                </Form.Item>

                                                <Form.Item name="cgst_rate" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} xl={6}>
                                                <Form.Item name="cgst_amount" label="CGST Amt.">
                                                    <Input placeholder="" readOnly={true} />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} xl={6}>
                                                <Form.Item name="sgst_id" label="SGST">
                                                    <Select className="text-left" allowClear={true} onChange={(value, event) => onSelectTapRegSGST(event, "DROPDOWN", 0)}
                                                    //disabled={savePreviosValueForWave.sgst_disable}
                                                    disabled={true}
                                                    >
                                                        {sgstList.length > 0
                                                            ? sgstList.map((sgst_list) => (
                                                                <Option
                                                                    key={sgst_list.id}
                                                                    value={sgst_list.id}
                                                                    rate={sgst_list.rate}
                                                                >
                                                                    {sgst_list.gstDescription}
                                                                </Option>
                                                            ))
                                                            : ""}
                                                    </Select>
                                                </Form.Item>
                                                <Form.Item name="sgst_rate" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} xl={6}>
                                                <Form.Item name="sgst_amount" label="SGST Amt.">
                                                    <Input placeholder="" readOnly={true} />
                                                </Form.Item>

                                                <Form.Item name="total_gst_amount" label="Total GST" hidden={true}>
                                                    <Input placeholder="" readOnly={true} />
                                                </Form.Item>

                                                <Form.Item name="net_amount" label="Net Amount" hidden={true}>
                                                    <Input placeholder="" readOnly={true} />
                                                </Form.Item>

                                            </Col>


                                            <Col xs={24} xl={18}>
                                                <Form.Item name="cr_ac_id" label="Account to be Credited" rules={[
                                                    {
                                                        required: true,
                                                        message: 'Account is required',
                                                    },
                                                ]}>
                                                    {/* <Select className="text-left" defaultValue="0"> */}

                                                    <Select
                                                        showSearch
                                                        placeholder="Search to Select"
                                                        optionFilterProp="children"
                                                        filterOption={(input, option) =>
                                                            // option.children.includes(input)
                                                            option.children.toLowerCase().includes(input.toLowerCase())
                                                        }
                                                        filterSort={(optionA, optionB) =>
                                                            optionA.children
                                                                .toLowerCase()
                                                                .localeCompare(optionB.children.toLowerCase())
                                                        }
                                                        placement="bottomLeft"

                                                        allowClear={true}
                                                        disabled={true}

                                                    >
                                                        {
                                                            accountList.length > 0 ?
                                                                accountList.map(account_data => (
                                                                    <Option key={account_data.id} value={account_data.id}>{account_data.account_name}</Option>

                                                                ))
                                                                : ''
                                                        }
                                                    </Select>
                                                </Form.Item>
                                            </Col>


                                        </Row>
                                    </Col>{" "}
                                    {/** end of column */}
                                    <Col xs={24} xl={12}>
                                        <Row gutter={20}>
                                            <Col xs={24} xl={24}>
                                                <StudentCardInfo
                                                    memberDisplayInfo={memberDisplayInfo}
                                                    memberDisplayOtherInfo={memberDisplayOtherInfo}
                                                />
                                                {/* {
                                                lastMembershipValidity ?  <Typography.Title
                                                level={5}
                                                style={{
                                                  marginTop: '0.5rem',
                                                }}
                                                
                                              >
                                                Last Membership Validity :  {lastMembershipValidity}
                                              </Typography.Title>  : <></>
                                               } */}

                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={24} xl={12}>
                                        {isAlreadyMemberEnrolled ? (
                                            <>
                                                <Form.Item name="" label=" ">
                                                    <Alert
                                                        message={alreadyMemberEnrolledMessage}
                                                        type="error"
                                                    />
                                                </Form.Item>
                                            </>
                                        ) : (
                                            ""
                                        )}
                                    </Col>
                                </Row>
                            </Panel>

                            <Panel
                                header={
                                    <>
                                        <h4>Receipt</h4>
                                    </>
                                }
                                key="receipt_jcp"
                                className="mainPanel"
                            >
                                <Collapse defaultActiveKey={["member_payment_panel"]} ghost>
                                    <Panel
                                        header="Receipt"
                                        key="member_payment_panel"
                                        className="member-payment component-panel innerPanel"
                                    >
                                        {/**
                       * Payments Module
                       */}

                                        <PaymentComponent
                                            enrollmentForm={form}
                                            detailInputKey="component_payment"
                                            addPaymentMode={addPaymentMode}
                                            paymentPaidList={paymentPaidList}
                                            removePayment={removePayment}
                                            remainingAmount={remainingAmount}
                                            isPaymentModeDisabled={isPaymentModeDisabled}
                                            //shortAdjustmentData={shortAdjustmentData}
                                        />
                                    </Panel>
                                </Collapse>

                                <div className="totalDetails">
                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text >Total Amount : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalAmount} </Text>
                                        </Col>
                                    </Row>
                                    <Row gutter={20} hidden={true}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text >Total Discount : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalDiscountAmount} </Text>
                                        </Col>
                                    </Row>

                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text >Total Taxable : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalTaxableAmount} </Text>
                                        </Col>
                                    </Row>

                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text >Total CGST : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalCGSTAmount} </Text>
                                        </Col>
                                    </Row>

                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text >Total SGST : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalSGSTAmount} </Text>
                                        </Col>
                                    </Row>

                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text >Total Net Amount : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalNetAmount} </Text>
                                        </Col>
                                    </Row>

                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text >Round Off : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalRoundOff} </Text>
                                        </Col>
                                    </Row>
                                    {/* <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text italic>Total Payable : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalPayableAmount} </Text>
                                        </Col>
                                    </Row> */}


                                    {/* -----Previous Code-------
                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text italic style={{ fontSize: "18px", color: "#fb3b3b" }}>Total Payable = Amount to pay + Bank Charges(if any)  :  </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong style={{ fontSize: "18px", color: "#fb3b3b" }}>{totalPayableAmount} + {totalBankCharges}</Text>
                                        </Col>
                                    </Row> */}


                                    {/* New Changes on 02/04/24 =================Start Here*/}

                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text italic style={{ fontSize: "18px", color: "#fb3b3b" }}>Amount to pay :  </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong style={{ fontSize: "18px", color: "#fb3b3b" }}>{totalPayableAmount}</Text>
                                        </Col>
                                    </Row>
                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text italic style={{ fontSize: "18px", color: "#fb3b3b" }}>Bank Charges(if any) :  </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong style={{ fontSize: "18px", color: "#fb3b3b" }}>{totalBankCharges}</Text>
                                        </Col>
                                    </Row>
                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text italic style={{ fontSize: "18px", color: "#fb3b3b" }}>Total Payable :  </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong style={{ fontSize: "18px", color: "#fb3b3b" }}>{(Number(totalPayableAmount) + Number(totalBankCharges)).toFixed(2)}</Text>
                                        </Col>
                                    </Row>
                                    {/* New Changes on 02/04/24 =================== Ends Here*/}


                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text italic style={{ fontSize: "18px", color: "#23910c" }}>Total Paid :  </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text style={{ fontSize: "18px", color: "#23910c" }}>{totalPaidAmount} </Text>
                                        </Col>
                                    </Row>


                                    <Row gutter={20} hidden={true}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text italic>Short / Excess Amount : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{remainingAmount.toFixed(2)} </Text>
                                        </Col>
                                    </Row>
                                </div>

                                {/* <ModalWithMessageAndAction /> */}

                                <Row justify="end">
                                    <Col>
                                        <Form.Item>
                                            {isSaveLoaderEnable ? (
                                                <Spin />
                                            ) : (
                                                <>
                                                    <Button
                                                        htmlType="submit"
                                                        shape="round"
                                                        disabled={isAlreadyMemberEnrolled}
                                                        className="custom-button-green"
                                                    >
                                                        Save <RightOutlined />
                                                    </Button>
                                                </>
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Panel>
                        </Collapse>
                    </Form>
                </Col>
            </Row>

            <Modal
                title={responseModalTitle}
                centered
                visible={openModal}
                open={openModal}
                // onCancel={handleCancel}
                closable={false}
                footer={[
                    <a href={printURL} target="_blank" rel="noopener noreferrer">
                        <Button htmlType="button" type="default"><PrinterOutlined /> Print</Button>
                    </a>
                    
                    ,

                    <Link to={`/tap/membershiplist/`} style={{ margin: 1 }}>
                        <Button htmlType="button" type="primary">
                            {" "}
                            <EyeOutlined /> View List
                        </Button>
                    </Link>,

                    <Link
                        to={`/tap/membership/`}
                        onClick={() => changeLocation("/tap/membership")}
                        style={{ margin: 1 }}
                    >
                        <Button htmlType="button" type="danger">
                            {" "}
                            <EyeOutlined /> Add More
                        </Button>
                    </Link>,

                    // <Button key="submit" type="danger" onClick={()=> resetFormFields() }  style={{margin:1}} >
                    //   <PlusOutlined /> Add More
                    // </Button>,
                ]}
                style={{ width: "100px" }}
                className="responseModal"
            >
                <div style={{ textAlign: "center" }}>
                    <CheckCircleTwoTone
                        twoToneColor="#52c41a"
                        style={{ fontSize: "2.5rem" }}
                    />
                    <h3>{responseModalMessage}</h3>
                </div>
            </Modal>
        </div>
    );
};

export default TapMembership;
